export default __webpack_public_path__ + "static/intermountain-white-30817d0b3bd4337aaabcc6ddd2841f70.svg";